<template>
  <ui-button v-bind="$attrs" secondary :class="$style.dangerButton">
    <!-- @slot content of the button -->
    <slot />
  </ui-button>
</template>

<script setup lang="ts">
import { defineComponent } from 'vue'
import UiButton from './UiButton.vue'

defineOptions({
  inheritAttrs: false,
})

defineComponent({
  name: 'UiDangerButton',
})
</script>

<style lang="scss" module>
@use 'ui-danger-button.scss' as *;
</style>
